import ExternalStorageBaseScreen from "../../mapping_tool/UpdateNodes/shared/externalStorage/ExternalStorageBaseScreen";

export const ExternalStorageBase = () => <ExternalStorageBaseScreen variant="simulate" />;
